import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@pg-env/environment';

@Injectable({
  providedIn: 'root'
})
export class MyOutstandingAmountService {
  public customerApi: string;
  constructor(private http: HttpClient) {
    this.customerApi = environment.customerApiUrl;
  }

  public getOutstandingAmount(params): Observable<any> {
    return this.http.post<any>(`${this.customerApi}/balance/client-outstanding-amount`, params);
  }
  public getOutstandingTrade(params): Observable<any> {
    return this.http.post<any>(`${this.customerApi}/balance/client-outstanding-trades`, params);
  }
}
